import moment from 'moment-timezone'
import {OUTPUT_DATE_FORMAT, OUTPUT_SHORTDATE_FORMAT} from './commons'
import store from '../store'
export function _findObj(array, search_value, search_key = 'value', get_key = 'text') {
    if( !Array.isArray(array) ){
        return ''
    }
    var obj = array.find( x => x[search_key] === search_value )
    if( typeof obj === 'object' && obj != undefined ) {
        return obj[get_key]
    }
    return ''
}

export  function toLocal(time, options = {outputFormat: OUTPUT_SHORTDATE_FORMAT, inputFormat: 'YYYY-MM-DD HH:mm:ss'}) {
    var date = moment.utc(time, options.inputFormat)
    return date.isValid() ? moment(date).local().format(options.outputFormat) : 'NA'
}
export  function toLocalDate(time, options = {outputFormat: OUTPUT_DATE_FORMAT, inputFormat: 'YYYY-MM-DD HH:mm:ss'}) {
    var date = moment.utc(time, options.inputFormat)
    return date.isValid() ? moment(date).format(options.outputFormat) : 'NA'
}
export  function toLocalDateNA(time, options = {outputFormat: OUTPUT_DATE_FORMAT, inputFormat: 'YYYY-MM-DD HH:mm:ss'}) {
    var date = moment.utc(time, options.inputFormat)
    return date.isValid() ? moment(date).format(options.outputFormat) : ''
}
export function  actionCellRenderer(params) {
    let eGui = document.createElement('div')
    let abc =''
    if(params.data.stt ==='PENDING')
    {
        abc = '<a class="dropdown-item delete"  data-action="delete"> <i class="far fa-trash-alt mr-2"> </i> Delete</a>'
    }
    eGui.innerHTML = `<div>
          <i class="fas fa fa-ellipsis-v actionBtn"  data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
          <div class="dropdown-menu"   aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item edit"  data-action="edit"> <i class="far fa-edit mr-2"></i> Edit</a>`+
              abc +' </div> </div>  '
    return eGui
}

export function ProviderActionCellRenderer(params){
    let eGui = document.createElement('div')
    let abc = ''
    if (params.data.stt === 'PENDING') {
        abc =
          '<a class="dropdown-item delete"  data-action="delete"> <i class="far fa-trash-alt mr-2"> </i> Delete</a>'
    }
    const isDisabled = params.data.notisphere_managed === 'No'
    eGui.innerHTML =
        `<div >
                    <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false" ></i>
                    <div class="dropdown-menu"   aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item edit"  data-action="edit"> <i class="far fa-edit mr-2"></i> Edit</a>
                        <a class="dropdown-item ${
    isDisabled ? 'disabled' : ''
}"  data-action="intake-settings"> <i class="fas fa-cog mr-2"></i> Intake Settings</a>` +
        abc +
        ' </div> </div>  '
    return eGui
}

export function recallActionRenderCell (params) {
    let eGui = document.createElement('div')
    eGui.innerHTML =
        `<div>
          <i class="fas fa fa-ellipsis-v actionBtn"  data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
              <div class="dropdown-menu"   aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item view"  data-action="view"> <i class="far fa fa-eye mr-2"></i> View</a>
              </div>
        </div>`
    return eGui
}

export function supplierListActionRenderCell(params) {
    let eGui = document.createElement('div')
    const item = params.data
    let menuItems = []

    if (item.status !== 'LINKED') {
        menuItems.push('<a class="dropdown-item" data-action="edit"><i class="far fa-edit mr-2"></i>Edit</a>')
    }

    if (item.status === 'ACTIVE' || item.status === 'PENDING' || item.status === 'LINKED') {
        menuItems.push('<a class="dropdown-item" data-action="link"><i class="fa fa-link mr-2"></i>Link</a>')
    }

    if (item.status === 'ACTIVE') {
        menuItems.push('<a class="dropdown-item" data-action="deactivate"><i class="fa fa-lock mr-2"></i>Deactivate</a>')
    }

    if (item.status === 'PENDING') {
        menuItems.push('<a class="dropdown-item" data-action="activate"><i class="fas fa-check-double mr-2"></i>Activate</a>')
        menuItems.push('<a class="dropdown-item" data-action="deactivate"><i class="fa fa-lock mr-2"></i>Deactivate</a>')
    }

    if (item.status === 'DEACTIVATED') {
        menuItems.push('<a class="dropdown-item" data-action="activate"><i class="fas fa-check-double mr-2"></i>Activate</a>')
    }

    eGui.innerHTML = `<div>
        <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            ${menuItems.join('')}
        </div>
    </div>`
    return eGui
}

export function supplierRecallActionRenderCell(params) {
    let el = document.createElement('div')
    if(params.data.allow_access){
        if (params.data.status == 'CLOSED') {
            el.innerHTML = `<div >
      <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
      </div> 
    </div>`
        }
        else if (params.data.status == 'OPEN') {
            el.innerHTML = `<div >
      <i class="fas fa fa-ellipsis-v actionBtn"  data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false" ></i>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
          <a class="dropdown-item edit" data-action="edit"> <i class="far fa fa-edit mr-2"></i>  Edit</a>
      </div> 
    </div>`
        }
        else{
            el.innerHTML = `<div>
      <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false" ></i>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
          <a class="dropdown-item edit" data-action="edit"> <i class="far fa fa-edit mr-2"></i>  Edit</a>
          <a class="dropdown-item view"  data-action="delete"><i class="far fa-trash-alt mr-2"> </i>Delete</a>
      </div> 
    </div>`
        }
    }
    return el
}

export function providerRecallActionRenderCell(params) {
    let el = document.createElement('div')
    if(params.data.isProviderCreated){
        if(params.data.status_provider == 'COMPLETED'){
            el.innerHTML = `<div>
    <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
        <a class="dropdown-item edit disabled"> <i class="far fa fa-edit mr-2"></i>  Edit</a>
    </div> 
  </div>`
        }
        else{
            el.innerHTML = `<div>
      <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
      <a class="dropdown-item edit" data-action="edit"> <i class="far fa fa-edit mr-2"></i>  Edit</a>
    </div> 
      </div>
      `
        }
    }
    else{
        el.innerHTML = `<div>
    <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
    </div> 
    </div>
    `
    }
    // if(store.state.user.id != params.data.createdUserId)
    // {
    //     el.innerHTML = el.innerHTML.replace('<a class="dropdown-item edit" data-action="edit"> <i class="far fa fa-edit mr-2"></i>  Edit</a>', '')
    //     el.innerHTML = el.innerHTML.replace('<a class="dropdown-item edit disabled"> <i class="far fa fa-edit mr-2"></i>  Edit</a>', '')
    // }
    // if(!params.data.isEdit)
    // {
    //     el.innerHTML = el.innerHTML.replace('<a class="dropdown-item edit" data-action="edit"> <i class="far fa fa-edit mr-2"></i>  Edit</a>', '')
    //     el.innerHTML = el.innerHTML.replace('<a class="dropdown-item edit disabled"> <i class="far fa fa-edit mr-2"></i>  Edit</a>', '')
    // }
    return el
}
export function supplierDisruptionActionRenderCell(params) {
    let el = document.createElement('div')
    if(params.data.allow_access){
        if (params.data.status == 'CLOSED') {
            el.innerHTML = `<div>
      <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
      </div> 
    </div>`
        }
        else if(params.data.status == 'OPEN')
        {
            el.innerHTML = `<div>
      <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
          <a class="dropdown-item edit" data-action="edit"> <i class="far fa fa-edit mr-2"></i>  Edit</a>
      </div> 
    </div>`
        }
        else{
            el.innerHTML = `<div>
      <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
          <a class="dropdown-item edit" data-action="edit"> <i class="far fa fa-edit mr-2"></i>  Edit</a>
          <a class="dropdown-item view"  data-action="delete"><i class="far fa-trash-alt mr-2"> </i>Delete</a>
      </div> 
    </div>`
        }
    }
    return el
}
export function ErResponseActions(params) {
    let el = document.createElement('div')
    if(store.state.user.id == params.data.userid)
    {
        if (params.data.response_status == 'DRAFT') {
            el.innerHTML = `<div>
      <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <a class="dropdown-item edit" data-action="edit"> <i class="far fa fa-edit mr-2"></i>  Edit</a>
      <a class="dropdown-item respond" data-action="respond"><i class="fa fa-reply mr-2"></i>  Respond</a>
          <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
          <a class="dropdown-item delete"  data-action="delete"><i class="far fa-trash-alt mr-2"> </i>Delete</a>
      </div> 
    </div>`
        }
        else if(params.data.response_status == 'ERROR')
        {
            el.innerHTML = `<div>
      <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
      <a class="dropdown-item edit" data-action="edit"> <i class="far fa fa-edit mr-2"></i>  Edit</a>
      <a class="dropdown-item responde" data-action="respond"><i class="fa fa-reply mr-2"></i>  Respond</a>
          <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
          <a class="dropdown-item delete"  data-action="delete"><i class="far fa-trash-alt mr-2"> </i>Delete</a>
      </div> 
    </div>`
        }
        else{
            el.innerHTML = `<div>
      <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
          <a class="dropdown-item delete"  data-action="delete"><i class="far fa-trash-alt mr-2"> </i>Delete</a>
      </div> 
    </div>`
        }
    }
    else
    {
        el.innerHTML = `<div>
      <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
      </div> 
    </div>`
    }

    return el
}

export function NotisphereErResponseActions(params) {
    let el = document.createElement('div')
    el.innerHTML = `<div>
      <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
      </div> 
    </div>`
    return el
}

export function supplierLocationActionRenderCell (params) {
    let eGui = document.createElement('div')
    eGui.innerHTML = `<div >
            <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
            <div class="dropdown-menu"   aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item edit"  data-action="edit"> <i class="far fa-edit mr-2"></i>Edit</a>
            <a class="dropdown-item view"  data-action="delete"><i class="far fa-trash-alt mr-2"> </i>Delete</a>
            </div> </div>`
    return eGui
}
export function notisphereLocationActionRenderCell (params) {
    let eGui = document.createElement('div')
    eGui.innerHTML = `<div >
            <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
            <div class="dropdown-menu"   aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item view"  data-action="delete"><i class="far fa-trash-alt mr-2"> </i>Delete</a>
            </div> </div>`
    return eGui
}
export function notisphereLocationVerificationActionRenderCell (params) {
    let eGui = document.createElement('div')
    eGui.innerHTML = `<div >
            <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
            <div class="dropdown-menu"   aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item edit"  data-action="edit"><i class="far fa-edit mr-2"></i>Edit</a>
            </div> </div>`
    return eGui
}
export function supplierSalesRepActionRenderCell (params) {
    let eGui = document.createElement('div')
    if (params.data.status == 'ACTIVE') {
        eGui.innerHTML = `<div >
            <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
            <div class="dropdown-menu"   aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item edit"  data-action="edit"> <i class="far fa-edit mr-2"></i>Edit</a>
            <a class="dropdown-item view"  data-action="inactive"><i class="fa fa-lock  mr-2"></i>Inactivate</a>
            </div> </div>`
    }
    else{
        eGui.innerHTML = `<div >
            <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
            <div class="dropdown-menu"   aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item view"  data-action="active"><i class="fas fa-check-double  mr-2"></i>Activate</a>
            </div> </div>`
    }
    return eGui
}

export function distributionListsActionRenderCell (params) {
    let eGui = document.createElement('div')
    if (params.data.status == 'ACTIVE') {
        eGui.innerHTML = `<div >
            <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
            <div class="dropdown-menu"   aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item edit"  data-action="edit"> <i class="far fa-edit mr-2"></i>Edit</a>
            <a class="dropdown-item view"  data-action="inactive"><i class="fa fa-lock  mr-2"></i>Inactivate</a>
            </div> </div>`
    }
    else{
        eGui.innerHTML = `<div >
            <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
            <div class="dropdown-menu"   aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item view"  data-action="active"><i class="fas fa-check-double  mr-2"></i>Activate</a>
            </div> </div>`
    }
    return eGui
}
export function ProviderFdaActions(params) {
    let el = document.createElement('div')
    el.innerHTML = `<div>
      <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
          <a class="dropdown-item create" data-action="create"> <i class="far fa fa-edit mr-2"></i>  Create Recall</a>
      </div> 
    </div>`
    return el
}
export function supplierBillingSummaryActions(params) {
    let el = document.createElement('div')
    el.innerHTML = `<div>
      <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item view" data-action="view"> <i class="far fa fa-eye mr-2"></i>  View</a>
      </div> 
    </div>`
    return el
}
export function distributionListsNameRenderCell(params){
    let eGui = document.createElement('div')
    if (params.data.in_valid_email_count > 0) {
        eGui.innerHTML = `<div >
                <span style="background-color: #faf209;">${params.data.name}</span>
            </div>`
    }
    else{
        eGui.innerHTML = `<div >
                <span>${params.data.name}</span>
            </div>`
    }
    return eGui
}

export function notisphereUserActionRenderCell (params) {
    let eGui = document.createElement('div')
    if(params.data.status == 'DEACTIVATED') {
        eGui.innerHTML = `<div >
            <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
            <div class="dropdown-menu"   aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item edit"  data-action="edit"> <i class="far fa-edit mr-2"></i>Edit</a>
            </div> </div>`
    } else if(params.data.status == 'VERIFIED') {
        eGui.innerHTML = `<div >
            <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
            <div class="dropdown-menu"   aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item edit"  data-action="edit"> <i class="far fa-edit mr-2"></i>Edit</a>
            <a class="dropdown-item reset-pwd"  data-action="reset-pwd"><i class="fas fa-envelope-open-text mr-2"></i>Send Reset Password Email</a>
            </div> </div>`
    } else if(params.data.status == 'VERIFICATION') {
        eGui.innerHTML = `<div >
            <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
            <div class="dropdown-menu"   aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item edit"  data-action="edit"> <i class="far fa-edit mr-2"></i>Edit</a>
            <a class="dropdown-item resend-verification"  data-action="resend-verification"><i class="fas fa-envelope-open-text mr-2"></i>Send Verification Email</a>
            </div> </div>`
    } else if(params.data.status == 'DELETED'){
        eGui.innerHTML = `<div >
            <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
           </div>`
    } else {
        eGui.innerHTML = `<div >
            <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"></i>
            <div class="dropdown-menu"   aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item edit"  data-action="edit"> <i class="far fa-edit mr-2"></i>Edit</a>
            </div> </div>`
    }
    return eGui
}

export function toQueryParams(obj, prefix){
    var str = [],
        p
    for (p in obj) {
        if (Object.prototype.hasOwnProperty.call(obj,p)) {
            var k = prefix ? prefix + '[' + p + ']' : p,
                v = obj[p]
            str.push((v !== null && typeof v === 'object') ?
                toQueryParams(v, k) :
                encodeURIComponent(k) + '=' + encodeURIComponent(v))
        }
    }
    return str.join('&')
}
export function  getCommunicationType(communicationType,communicationSubType) {
    switch(communicationType) {
    case 'RECALL':
        return 'recall'
    case 'PRODUCT DISRUPTION':
        switch(communicationSubType) {
        case 'ALLOCATION':
            return 'allocation'
        case 'BACKORDER':
            return 'backorder'
        case 'DISCONTINUATION':
            return 'discontinuation'
        case 'GENERALINFORMATION':
            return 'general information'
        case 'MARKETEVENT':
            return 'market event'
        case 'PRODUCTORKITCHANGE':
            return 'product or kit change'
        case 'SHORTAGE':
            return 'shortage'
        default:
            return 'supply advisory'
        }
    default:
        return 'recall'
    }
}

export function  getCommunicationTypeTitleCase(communicationType,communicationSubType) {
    switch(communicationType) {
    case 'RECALL':
        return 'Recall'
    case 'PRODUCT DISRUPTION':
        switch(communicationSubType) {
        case 'ALLOCATION':
            return 'Allocation'
        case 'BACKORDER':
            return 'Backorder'
        case 'DISCONTINUATION':
            return 'Discontinuation'
        case 'GENERALINFORMATION':
            return 'General Information'
        case 'MARKETEVENT':
            return 'Market Event'
        case 'PRODUCTORKITCHANGE':
            return 'Product or Kit Change'
        case 'SHORTAGE':
            return 'Shortage'
        default:
            return 'Supply Advisory'
        }
    default:
        return 'recall'
    }
}

export function locationPreProcessorActionRenderCell(params) {
    let eGui = document.createElement('div')
    const item = params.data
    let menuItems = []

    if (item.status === 'ERROR' || item.status === 'PENDING') {
        menuItems.push('<a class="dropdown-item" data-action="edit"><i class="far fa-edit mr-2"></i>Edit</a>')
    }
    menuItems.push('<a class="dropdown-item" data-action="view"><i class="far fa-eye mr-2"></i>View</a>')
    if (item.status === 'PENDING' || item.status === 'ERROR') {
        menuItems.push('<a class="dropdown-item" data-action="deactivate"><i class="fas fa-lock mr-2"></i>Deactivate</a>')
    }
    eGui.innerHTML = `<div>
        <i class="fas fa fa-ellipsis-v actionBtn" style="cursor: pointer;" data-action="open" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            ${menuItems.join('')}
        </div>
    </div>`

    return eGui
}